import { Routes } from '@angular/router';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { homeRoutes } from './features/home/home.routing';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: 'home' , loadChildren: () => import('./features/home/home.routing').then((m) => m.homeRoutes) },
      { path: 'measure', loadChildren: () => import('./features/measure/measure.routing').then((m) => m.measureRoutes) },
      { path: 'analyse', loadChildren: () => import('./features/analyse/analyse.routing').then((m) => m.analyseRoutes) },
      { path: 'administration', loadChildren: () => import('./features/administration/administration.routing').then((m) => m.administrationRouting) },
      { path: 'contact-us', loadChildren: () => import('./features/support/support.routing').then((m) => m.supportRouting) },
      { path: 'cgu', loadComponent: () => import('./features/legals/pages/cgu/cgu.component').then((c) => c.CguComponent), title: 'cgu' },
      {
        path: 'legal-notice',
        loadComponent: () => import('./features/legals/pages/legal-notice/legal-notice.component').then((c) => c.LegalNoticeComponent),
        title: 'legalNotice'
      },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('./features/legals/pages/privacy-policy/privacy-policy.component').then((c) => c.PrivacyPolicyComponent),
        title: 'privacyPolicy'
      },
      { path: '**', redirectTo: 'home', pathMatch: 'full' }
    ]
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];
